function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.269,52.575h6.282v-6.2H31.269ZM34.41,3A31.211,31.211,0,0,0,3,33.984,31.211,31.211,0,0,0,34.41,64.969a31.211,31.211,0,0,0,31.41-30.984A31.211,31.211,0,0,0,34.41,3Zm0,55.772A24.993,24.993,0,0,1,9.282,33.984a25.13,25.13,0,0,1,50.256,0A24.993,24.993,0,0,1,34.41,58.772Zm0-43.378A12.476,12.476,0,0,0,21.846,27.788h6.282a6.283,6.283,0,0,1,12.564,0c0,6.2-9.423,5.422-9.423,15.492h6.282c0-6.971,9.423-7.746,9.423-15.492A12.476,12.476,0,0,0,34.41,15.394Z",
  transform: "translate(-3 -3)"
});

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62.819,
    height: 61.969,
    viewBox: "0 0 62.819 61.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.c041c54f.svg";
export { ForwardRef as ReactComponent };